import Box from '@mui/material/Box';
import { storyblokEditable } from '@storyblok/react';
import * as sdkTypes from '@vansite/ts-sharetribe-flex-sdk/types';
import React, { memo, useMemo } from 'react';

import { getListingsById } from '../../../ducks/marketplaceData.duck';
import useAppSelector from '../../../util/hooks/useAppSelector';
import ListingCard from '../../BasicUI/ListingCard/ListingCard';
import ListingCardSkeleton from '../../BasicUI/ListingCard/ListingCardSkeleton';
import { withBaseComponent } from '../hoc/withBaseComponent';
// Side-effect import: this module reads the SearchPage redux slice, which is injected
// lazily by the duck. Importing it keeps the reducer in whatever chunk this module lands in.
import '../../../containers/SearchPage/SearchPage.duck';

const { UUID } = sdkTypes;

/**
 * @param {object} props
 * @param {object} props.blok
 * @param {boolean} props.annualPassIsValid
 */
const StoryblokListingCardComponent = ({ blok, annualPassIsValid }) => {
  const { general, extra = { id: '' } } = blok;
  const { listingId = '', disableLink = false } = general;

  const entities = useAppSelector((state) => state.marketplaceData.entities);
  const listing = useMemo(
    () => getListingsById(entities, [new UUID(listingId)])[0],
    [entities, listingId],
  );
  const searchInProgress = useAppSelector((state) => state.SearchPage.searchInProgress);

  return (
    <Box id={extra.id} {...storyblokEditable(blok)}>
      {searchInProgress ? (
        <ListingCardSkeleton />
      ) : listing ? (
        <ListingCard
          annualPassIsValid={annualPassIsValid}
          disableLink={disableLink}
          listing={listing}
        />
      ) : null}
    </Box>
  );
};

StoryblokListingCardComponent.displayName = 'StoryblokListingCard';
const StoryblokListingCard = withBaseComponent(StoryblokListingCardComponent);

export default memo(StoryblokListingCard);
